import { Log } from '@iot-platform/models/i4b';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { DeviceCommentsActions } from '../actions';

export interface State extends EntityState<Log> {
  selectedId: string | null;
  loading: boolean;
  loaded: boolean;
  error: unknown;
}

export const adapter: EntityAdapter<Log> = createEntityAdapter<Log>({
  selectId: (entity: Log) => entity.id,
  sortComparer: false
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  loading: false,
  loaded: false,
  error: null
});

export const deviceCommentsFeature = createFeature({
  name: 'deviceComments',
  reducer: createReducer(
    initialState,
    on(
      DeviceCommentsActions.loadComments,
      (state: State): State => ({
        ...state,
        loading: true,
        loaded: false
      })
    ),
    on(
      DeviceCommentsActions.loadCommentsSuccess,
      (state: State, { comments }): State =>
        adapter.setAll(comments, {
          ...state,
          loading: false,
          loaded: true
        })
    ),
    on(
      DeviceCommentsActions.loadCommentsFailure,
      (state: State, { error }): State => ({
        ...state,
        loading: false,
        loaded: false,
        error
      })
    ),
    //
    on(DeviceCommentsActions.addComment, (state: State): State => ({ ...state, selectedId: null })),
    on(
      DeviceCommentsActions.addCommentSuccess,
      (state: State, { comment }): State =>
        adapter.addOne(comment, {
          ...state,
          selectedId: comment.id
        })
    ),
    on(
      DeviceCommentsActions.addCommentFailure,
      (state: State, { error }): State => ({
        ...state,
        selectedId: null,
        error
      })
    ),
    //
    on(DeviceCommentsActions.editComment, (state: State): State => ({ ...state, selectedId: null })),
    on(
      DeviceCommentsActions.editCommentSuccess,
      (state: State, { comment }): State =>
        adapter.updateOne(
          { id: comment.id, changes: comment },
          {
            ...state,
            selectedId: comment.id
          }
        )
    ),
    on(
      DeviceCommentsActions.editCommentFailure,
      (state: State, { error }): State => ({
        ...state,
        selectedId: null,
        error
      })
    ),
    //
    on(DeviceCommentsActions.deleteComment, (state: State): State => ({ ...state, selectedId: null })),
    on(
      DeviceCommentsActions.deleteCommentSuccess,
      (state: State, { commentId }): State =>
        adapter.removeOne(commentId, {
          ...state,
          selectedId: null
        })
    ),
    on(
      DeviceCommentsActions.deleteCommentFailure,
      (state: State, { error }): State => ({
        ...state,
        selectedId: null,
        error
      })
    )
  )
});
